const VOUCHER_CODE_TYPE = Object.freeze({
  auto: 'auto-code',
  custom: 'custom-code',
});

export default VOUCHER_CODE_TYPE;
